import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterDate,
  TAdvancedFilterSingle,
  TFilterDateOptions,
} from '../../../../models/advanced-filter.model';
import {
  dateFilterCreatedOperatorOptionsExtended,
  dateFilterUpdatedOperatorOptionsExtended,
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
  dateFilterOperatorOptionsExtended,
} from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-date',
  templateUrl: './advanced-filter-date.component.html',
  styleUrls: ['./advanced-filter-date.component.scss'],
  standalone: false,
})
export class AdvancedFilterDateComponent implements OnChanges {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();
  @Input() ppType: 'date_created' | 'date_updated' | 'date';

  option: TFilterDateOptions;
  filter: TAdvancedFilterDate;

  startDate: number;
  endDate: number;
  today = new Date().getTime();
  maxDate: null | number = null;

  advancedFilterDateOptions: TSelectOption[];
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    switch (this.ppType) {
      case 'date_created':
        this.advancedFilterDateOptions = dateFilterCreatedOperatorOptionsExtended;
        break;
      case 'date_updated':
        this.advancedFilterDateOptions = dateFilterUpdatedOperatorOptionsExtended;
        break;
      case 'date':
      default:
        this.advancedFilterDateOptions = dateFilterOperatorOptionsExtended;
        break;
    }

    if (this.ppFilter && !this.ppFilter?.value) {
      this.ppFilter.value = [null, ''];
    }

    this.filter = this.ppFilter as TAdvancedFilterDate;

    this.startDate = this.filter.value?.[0] ? this.filter.value[0] : null;
    this.endDate = this.filter.value?.[1] ? this.filter.value[1] : null;
    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.filter.option = newCondition.value as TFilterDateOptions;
    this.option = newCondition.value as TFilterDateOptions;

    this.filter.operator = newCondition.operator;
    this.filter.timelinePosition = newCondition.timelinePosition;

    if (newCondition.operator === EPointSearchOperator.BETWEEN && !this.ppFilter.value[1]) {
      this.ppFilter.value = [this.ppFilter.value[0], null];
    } else {
      this.ppFilter.value = [this.ppFilter.value[0]];
    }

    this.applyChanges();
  }

  applyChanges(): void {
    if (this.filter.value?.every((v) => v === null)) {
      this.filter.value = null;
    }

    if (
      this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.ppFilter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      const data: number[] = (this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY
        ? IS_EMPTY_NUMERICAL.data
        : IS_NOT_EMPTY_NUMERICAL.data) as unknown as number[];
      this.filter.value = data;
    }

    this.ppFilterChange.emit(this.filter);
  }

  changeFieldValue(value: Date[], index: number): void {
    const date = value[0];

    if (!this.filter.value) {
      this.filter.value = [null, null];
    }

    this.filter.value[index] = date.getTime();

    switch (index) {
      case 0:
        this.startDate = value[0].getTime();
        break;
      case 1:
        this.endDate = value[0].getTime();
        break;
    }
    this.applyChanges();
  }
}
